const frExtends = {
    ra: {
        page: {
            create: 'Création %{name}'
        }
    }
};
export default frExtends;